
    import React from 'react';
    import { useInquiryCreate, useInquirySoftDelete,useInquiryMultipleSoftDelete, useInquiryUpdate } from '../../queries/Inquiry.queries';
    import Inquiry from './Inquiry';
    
    const InquiryContainer = () => {
    
      const {mutate:addRecord} = useInquiryCreate();
      const {mutate:editRecord} = useInquiryUpdate();
      const {mutate:deleteRecord} = useInquirySoftDelete();
      const {mutate:deleteRecords} = useInquiryMultipleSoftDelete();
    
      const onAddRecord = (record) => {
        return new Promise((resolve,reject) => {
          addRecord(record, {
            onSuccess: async () => resolve('Record created successfully.'),
            onError: async (error) => reject(error?.message),
          });
        })
      };
    
      const onEditRecord = (record) => {
        return new Promise((resolve, reject) => {
          editRecord(
            record,
            {
              onSuccess: async () => resolve('Record updated successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };
    
      const onDeleteRecord = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecord(
            record, 
            {
              onSuccess: async () => resolve('Record deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      const onMultiDelete = (record) => {
        return new Promise((resolve, reject) => {
          deleteRecords(
            record, 
            {
              onSuccess: async () => resolve('Records deleted successfully.'),
              onError: async (error) => reject(error?.message),
            }
          );
        });
      };

      return (
        <Inquiry 
          addRecord={onAddRecord}
          deleteRecord={onDeleteRecord}
          deleteRecords={onMultiDelete}
          editRecord={onEditRecord}
        />
      )
    }
    
    export default InquiryContainer;
    